import { JSX } from "solid-js";

export interface BackgroundGradientV2Props {
  /**
   * The color of the ellipse gradient
   * Can be any valid CSS color (hex, rgb, rgba, etc.)
   */
  color: string;
}

/**
 * Background Gradient v2 Component
 * Displays an ellipse with layer blur effect
 * Reusable across different views with customizable color
 */
export function BackgroundGradientV2(
  props: BackgroundGradientV2Props
): JSX.Element {
  return (
    <div class="pointer-events-none absolute left-0 right-0 top-0 h-[350px] overflow-hidden">
      <div class="absolute left-1/2  h-[222px] w-full max-w-[1110px] -translate-x-1/2 -translate-y-1/2">
        {/* Ellipse with blur effect */}
        <div
          class="absolute inset-0"
          style={{
            filter: "blur(80px)",
          }}
        >
          <svg
            viewBox="0 0 1110 222"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="h-full w-full"
          >
            <ellipse
              cx="555"
              cy="111"
              rx="555"
              ry="111"
              class="opacity-20"
              fill={props.color}
            />
          </svg>
        </div>
      </div>
    </div>
  );
}
